// Spring tokens (HANDOVER §5.1). Starting points; tune on the phone.
export const springs = {
  snappy: { type: 'spring', stiffness: 500, damping: 38, mass: 1 },
  pop: { type: 'spring', stiffness: 420, damping: 22, mass: 1 },
  bounce: { type: 'spring', stiffness: 600, damping: 14, mass: 1 },
  slap: { type: 'spring', stiffness: 900, damping: 30, mass: 1.2 },
  wobble: { type: 'spring', stiffness: 300, damping: 8, mass: 1 },
} as const
